/**
 * Classify a thrown cloud-processing error into a UI-actionable reason.
 * Prefers the structured .status/.code attached by cloudbridge; falls back to
 * message heuristics for older throw sites.
 *
 * Returns: 'rate_limited' | 'auth' | 'network' | 'server'
 */
export function classifyCloudError(err) {
  const status = err?.status;
  const code = err?.code;
  if (status === 429 || code === 'anon_daily_limit') return 'rate_limited';
  const msg = String(err?.message || err);
  if (status === 401 || /sign|signed in|unauth/i.test(msg)) return 'auth';
  if (/network|fetch|aborted|taking too long/i.test(msg)) return 'network';
  return 'server';
}
